/**
 * Computes fixed position for dropdowns so they stay in view.
 * If there isn't enough space below the trigger, the dropdown is positioned above it.
 */
const DEFAULT_ESTIMATED_HEIGHT_PX = 220

export function getDropdownPositionRight(
  triggerRect: DOMRect,
  estimatedHeightPx: number = DEFAULT_ESTIMATED_HEIGHT_PX
): { top: number; right: number } {
  const right = window.innerWidth - triggerRect.right
  const spaceBelow = window.innerHeight - triggerRect.bottom - 16
  const top =
    spaceBelow >= estimatedHeightPx
      ? triggerRect.bottom + 8
      : Math.max(8, triggerRect.top - estimatedHeightPx - 8)
  return { top, right }
}

/** Same flip logic for left-aligned dropdowns (e.g. ArtistSwitcher). */
export function getDropdownPositionLeft(
  triggerRect: DOMRect,
  estimatedHeightPx: number = DEFAULT_ESTIMATED_HEIGHT_PX
): { top: number; left: number } {
  const left = triggerRect.left
  const spaceBelow = window.innerHeight - triggerRect.bottom - 16
  const top =
    spaceBelow >= estimatedHeightPx
      ? triggerRect.bottom + 8
      : Math.max(8, triggerRect.top - estimatedHeightPx - 8)
  return { top, left }
}
